import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=7bdf4f3f&scoped=true&"
import script from "./RecordTable.vue?vue&type=script&lang=js&"
export * from "./RecordTable.vue?vue&type=script&lang=js&"
import style0 from "./RecordTable.vue?vue&type=style&index=0&id=7bdf4f3f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdf4f3f",
  null
  
)

export default component.exports